<template>
    <div id="animated-header" class="text-yanone text-uppercase">
        <div id="animated-header-names-wrapper" :class="{ animate }">
            <div class="animated-header-names">
                <template v-for="index in elementsCount">
                    <span>{{ labels[index % labels.length] }}</span>
                </template>
            </div>
            <div class="animated-header-names">
                <template v-for="index in elementsCount">
                    <span>{{ labels[(elementsCount - index) % labels.length] }}</span>
                </template>
            </div>
        </div>

        <div id="animated-header-overlay"></div>

        <div id="animated-header-art" v-if="art">
            <img :data-src="art" class="lazy lazy-fade">
        </div>
        <h1 v-else-if="title" class="headline text-default-5">
            {{title}}
        </h1>
    </div>
</template>

<script>
    import {lazyLoadInstance} from "../../../common/common";

    export default {
        name: "AnimatedHeader",
        
        props: {
            animate: {
                type: Boolean,
                default: true
            },
            labels: Array,
            art: String,
            title: String
        },

        data() {
            return {elementsCount: 250}
        },
        
        mounted() {
            lazyLoadInstance.update();
        }
    }
</script>